function convertToRGBNumers(rgbString) {
  return rgbString.replace(/[^\d,]/g, '').split(',').map(n => +n);
}

function calculateStep(min, max, length) {
  const count = length || 2;
  return Math.abs(max - min) / count;
}

const interpalateColor = (colorStart, colorEnd, factor) => {
  const from = Array.isArray(colorStart) ? colorStart : convertToRGBNumers(colorStart);
  const to = Array.isArray(colorEnd) ? colorEnd : convertToRGBNumers(colorEnd);
  const r = Math.round(from[0] * (1 - factor) + to[0] * factor);
  const g = Math.round(from[1] * (1 - factor) + to[1] * factor);
  const b = Math.round(from[2] * (1 - factor) + to[2] * factor);
  return `rgb(${r},${g},${b})`;
};

const clipFactor = factor => {
  if (factor < 0) return 0;
  if (factor > 1) return 1;
  return factor;
};

const colorCreatorWithRange = (baseColor, value, min, max) => {
  const rgbColor = convertToRGBNumers(baseColor);
  let finalValue = value;

  if (value < min) {
    finalValue = min;
  }

  if (value > max) {
    finalValue = max;
  }

  const range = max - min;
  const factor = (finalValue - min) / range * 0.8 + 0.2;
  const r = Math.round(255 - (255 - rgbColor[0]) * factor);
  const g = Math.round(255 - (255 - rgbColor[1]) * factor);
  const b = Math.round(255 - (255 - rgbColor[2]) * factor);
  return `rgb(${r},${g},${b}) `;
};

const valueToColor = (baseColor, value, min, max) => {
  const rgbColor = convertToRGBNumers(baseColor);
  let finalValue = value;

  if (value < min) {
    finalValue = min;
  }

  if (value > max) {
    finalValue = max;
  }

  const split = (min * 2 + max) / 3;

  if (finalValue < split) {
    let factor = (finalValue - min) / (split - min) * 0.8 + 0.2;
    factor = clipFactor(factor);
    const r = Math.round(255 - (255 - rgbColor[0]) * factor);
    const g = Math.round(255 - (255 - rgbColor[1]) * factor);
    const b = Math.round(255 - (255 - rgbColor[2]) * factor);
    return `rgb(${r},${g},${b})`;
  }

  let factor = (max - finalValue) / (max - split);
  factor = clipFactor(factor);
  const r = Math.round(rgbColor[0] * factor);
  const g = Math.round(rgbColor[1] * factor);
  const b = Math.round(rgbColor[2] * factor);
  return `rgb(${r},${g},${b})`;
};

const colorCreatorWithDelta = (colors, value, min, max) => {
  const {
    from,
    to
  } = {
    from: convertToRGBNumers(colors.from),
    to: convertToRGBNumers(colors.to)
  };
  const delta = max - min;
  let factor = (value - min) / delta;
  factor = Math.max(0, Math.min(1, factor));
  const rgbString = interpalateColor(from, to, factor);
  return rgbString;
};

const calculationColor = (colors, value, min, max) => {
  if (value <= min) {
    return colors[0];
  }

  if (value >= max) {
    return colors[colors.length - 1];
  }

  const colorList = colors.slice(1, -1);
  const step = calculateStep(min, max, colorList.length);
  const index = Math.floor((value - min) / step);
  return colorList[index];
};

function generatePalette(colorStart, colorEnd, count) {
  const start = convertToRGBNumers(colorStart);
  const end = convertToRGBNumers(colorEnd);
  const countOfIterations = count - 1;
  let alpha = 0;
  const palette = [];

  for (let i = 0; i <= countOfIterations; i += 1) {
    palette.push(interpalateColor(start, end, alpha));
    alpha += 1.0 / countOfIterations;
  }

  return palette;
} // function getColorByThemeConfig(themeConfig, value) {
//   const { min, max, color } = themeConfig;
//   if (typeof color === 'array') {
//     // calculationColor(colors, min, max, step, value);
//   }
// }


export { calculateStep, calculationColor, colorCreatorWithDelta, colorCreatorWithRange, convertToRGBNumers, generatePalette, interpalateColor, valueToColor };